// src/components/AIAssistant/AIAssistant.jsx

import { Icon } from '@iconify/react';
import { useEffect, useRef, useState } from 'react';

const AIAssistant = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [showPagePreview, setShowPagePreview] = useState(null);
  const [voiceCommand, setVoiceCommand] = useState('');
  const [isProcessingVoice, setIsProcessingVoice] = useState(false);
  const [showVoiceMode, setShowVoiceMode] = useState(false);
  const [activeTab, setActiveTab] = useState('chat');
  const [voiceEnabled, setVoiceEnabled] = useState(false);
  const [isVoiceTabActive, setIsVoiceTabActive] = useState(false);
  const [isAutoProcessing, setIsAutoProcessing] = useState(false);

  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const recognitionRef = useRef(null);
  const silenceTimerRef = useRef(null);
  const autoProcessTimerRef = useRef(null);
  const lastTranscriptRef = useRef('');
  const audioRef = useRef(null);

  // ─── ELEVENLABS CONFIG ──────────────────────────────────────
  const ELEVENLABS_API_KEY = process.env.REACT_APP_ELEVENLABS_API_KEY || '';
  const ELEVENLABS_VOICE_ID = process.env.REACT_APP_ELEVENLABS_VOICE_ID || '21m00Tcm4TlvDq8ikWAM';
  const ELEVENLABS_URL = `https://api.elevenlabs.io/v1/text-to-speech/${ELEVENLABS_VOICE_ID}`;

  // DeepSeek API Key
  const DEEPSEEK_API_KEY = process.env.REACT_APP_DEEPSEEK_API_KEY || '';
  const AI_API_URL = 'https://api.deepseek.com/chat/completions';

  // ─── GET PRICING KNOWLEDGE ─────────────────────────────────────
  const getPricingKnowledge = () => {
    return `
╔══════════════════════════════════════════════════════════════╗
║                    PAKET ZENTRA LENGKAP                      ║
╚══════════════════════════════════════════════════════════════╝

┌─────────────────────────────────────────────────────────────┐
│ BASIC - Rp1.500.000/bulan                                  │
│ Untuk startup & UMKM                                      │
├─────────────────────────────────────────────────────────────┤
│ KAPASITAS:                                                │
│ • 3 User Admin                                            │
│ • Maks. 50 Karyawan                                      │
│ • 1 Perusahaan                                           │
├─────────────────────────────────────────────────────────────┤
│ REKRUTMEN:                                                │
│ • Dashboard Recruitment                                  │
│ • Lowongan Kerja (Maks. 50 Job Posting)                  │
│ • Kandidat                                              │
│ • Lamaran Online                                        │
│ • Tes Online                                            │
│ • Interview                                             │
│ • Offering & Hiring                                     │
│ • Laporan Recruitment                                   │
│ • Database Kandidat                                     │
├─────────────────────────────────────────────────────────────┤
│ AI RECRUITMENT & AI HR ASSISTANT:                         │
│ • AI Screening CV — maks. 75 CV/hari                    │
│ • AI HR ASSISTANT — maks. 30 prompt/hari                │
├─────────────────────────────────────────────────────────────┤
│ MANAJEMEN KARYAWAN:                                      │
│ • Dashboard Manajemen Karyawan                          │
│ • Data Pegawai                                         │
│ • Shift Kerja                                          │
│ • Absensi                                              │
│ • Selfie Attendance                                     │
│ • Lokasi Absensi                                       │
│ • Cuti & Izin                                          │
│ • Dokumen HR                                           │
│ • Payroll                                              │
│ • Slip Gaji                                            │
│ • Laporan HR                                           │
├─────────────────────────────────────────────────────────────┤
│ SUPPORT:                                                 │
│ • Support melalui email/chat WhatsApp                   │
│ • Help Center Website                                   │
└─────────────────────────────────────────────────────────────┘

┌─────────────────────────────────────────────────────────────┐
│ PROFESSIONAL - Rp2.700.000/bulan ⭐ PALING POPULER        │
│ Untuk perusahaan menengah                                │
├─────────────────────────────────────────────────────────────┤
│ KAPASITAS:                                               │
│ • 10 User Admin                                          │
│ • Maks. 300 Karyawan                                    │
│ • 1 Perusahaan                                          │
│ • Semua fitur BASIC                                     │
├─────────────────────────────────────────────────────────────┤
│ REKRUTMEN:                                               │
│ • Dashboard Recruitment                                 │
│ • Lowongan Kerja — UNLIMITED Job Posting               │
│ • Kandidat                                             │
│ • Lamaran Online                                       │
│ • Tes Online                                           │
│ • Interview                                            │
│ • Offering & Hiring                                    │
│ • Laporan Recruitment                                  │
│ • Database Kandidat                                    │
├─────────────────────────────────────────────────────────────┤
│ AI RECRUITMENT & AI HR ASSISTANT:                        │
│ • AI Screening CV — maks. 200 CV/hari                  │
│ • AI HR ASSISTANT — maks. 75 prompt/hari               │
├─────────────────────────────────────────────────────────────┤
│ MANAJEMEN KARYAWAN:                                     │
│ • Dashboard Manajemen Karyawan                        │
│ • Data Pegawai                                        │
│ • Shift Kerja                                         │
│ • Absensi                                             │
│ • Selfie Attendance                                    │
│ • Lokasi Absensi                                      │
│ • Cuti & Izin                                         │
│ • Dokumen HR                                          │
│ • Payroll                                             │
│ • Slip Gaji                                           │
│ • Laporan HR                                          │
├─────────────────────────────────────────────────────────────┤
│ 💰 FINANCE BASIC:                                       │
│ • Finance Dashboard                                    │
│ • Pendapatan                                          │
│ • Pengeluaran                                         │
│ • Cash Flow                                           │
│ • Invoice                                             │
│ • Tagihan                                             │
│ • Pembayaran                                          │
│ • Budget Dasar                                        │
│ • Laporan Keuangan Dasar                              │
│ • Expense Management dasar                            │
├─────────────────────────────────────────────────────────────┤
│ 📣 DIGITAL MARKETING BASIC:                            │
│ • Marketing Dashboard                                  │
│ • Campaign Management                                  │
│ • Lead Management dasar                               │
│ • Content Planning                                    │
│ • Content Calendar                                    │
│ • Social Media Planning                               │
│ • Marketing Activity                                  │
│ • Marketing Report dasar                              │
│ • Basic Marketing Analytics                           │
├─────────────────────────────────────────────────────────────┤
│ SUPPORT:                                                │
│ • Priority Support                                     │
│ • Email & Chat Support                                 │
└─────────────────────────────────────────────────────────────┘

┌─────────────────────────────────────────────────────────────┐
│ ENTERPRISE - Rp6.300.000/bulan                            │
│ Untuk korporasi besar                                    │
├─────────────────────────────────────────────────────────────┤
│ KAPASITAS:                                               │
│ • UNLIMITED User Admin                                  │
│ • UNLIMITED Karyawan                                    │
│ • Maks. 3 Company                                       │
│ • Semua Fitur Professional                              │
├─────────────────────────────────────────────────────────────┤
│ REKRUTMEN:                                               │
│ • Dashboard Recruitment                                 │
│ • Lowongan Kerja — UNLIMITED Job Posting               │
│ • Kandidat                                             │
│ • Lamaran Online                                       │
│ • Tes Online                                           │
│ • Interview                                            │
│ • Offering & Hiring                                    │
│ • Laporan Recruitment                                  │
│ • Database Kandidat                                    │
├─────────────────────────────────────────────────────────────┤
│ AI RECRUITMENT & AI HR ASSISTANT:                        │
│ • AI Screening CV — maks. 500 CV/hari                  │
│ • AI HR ASSISTANT — maks. 300 prompt/hari              │
├─────────────────────────────────────────────────────────────┤
│ MANAJEMEN KARYAWAN ENTERPRISE:                          │
│ • Dashboard Manajemen Karyawan                        │
│ • Data Pegawai                                        │
│ • Shift Kerja                                         │
│ • Absensi                                             │
│ • Selfie Attendance                                    │
│ • Lokasi Absensi                                      │
│ • Cuti & Izin                                         │
│ • Performance Management                               │
│ • KPI Management                                      │
│ • Career Development                                  │
│ • Training Management                                 │
│ • Document Management                                 │
│ • HR Analytics                                        │
│ • Audit Log                                           │
│ • Advanced Payroll                                    │
│ • Slip Gaji                                           │
│ • Laporan HR                                          │
├─────────────────────────────────────────────────────────────┤
│ 💰 FINANCE ENTERPRISE:                                  │
│ • Finance Dashboard                                    │
│ • Income Management                                   │
│ • Expense Management                                  │
│ • Cash Flow                                           │
│ • Budget Management                                   │
│ • Invoice                                             │
│ • Billing                                             │
│ • Payment                                             │
│ • Account Receivable                                  │
│ • Account Payable                                     │
│ • Expense Approval                                    │
│ • Budget Approval                                     │
│ • Financial Reporting                                 │
│ • Profit & Loss                                       │
│ • Cash Flow Report                                    │
│ • Financial Analytics                                 │
│ • Multi-Account                                       │
│ • Multi-Branch                                        │
│ • Multi-Company                                       │
├─────────────────────────────────────────────────────────────┤
│ 📣 DIGITAL MARKETING ENTERPRISE:                       │
│ • Marketing Dashboard                                  │
│ • Campaign Management                                 │
│ • Lead Management                                     │
│ • Content Planning                                    │
│ • Content Calendar                                    │
│ • Social Media Planning                               │
│ • Marketing Activity                                  │
│ • Campaign Budget                                     │
│ • Marketing Expense                                   │
│ • Conversion Tracking                                 │
│ • Lead Source Analytics                               │
│ • Marketing Analytics                                 │
│ • Campaign ROI                                        │
│ • Marketing Report                                    │
│ • Campaign Approval Workflow                          │
├─────────────────────────────────────────────────────────────┤
│ SECURITY & SUPPORT:                                     │
│ • Advanced Role & Permission                           │
│ • Audit Log                                           │
│ • Enterprise Security                                 │
│ • Dedicated Support                                   │
│ • Priority Technical Support                          │
│ • SLA 99.9%                                           │
└─────────────────────────────────────────────────────────────┘

┌─────────────────────────────────────────────────────────────┐
│ CUSTOM / CORPORATE - Custom Pricing                      │
│ Untuk korporasi dan kebutuhan khusus                    │
├─────────────────────────────────────────────────────────────┤
│ • Mendapatkan seluruh kemampuan Enterprise              │
│ • Dapat disesuaikan dengan kebutuhan perusahaan         │
├─────────────────────────────────────────────────────────────┤
│ CUSTOM BUSINESS MODULE:                                 │
│ • Custom Module                                        │
│ • Custom Dashboard                                     │
│ • Custom Workflow                                      │
│ • Custom Report                                        │
│ • Custom Approval                                      │
│ • Custom Role                                          │
│ • Custom Permission                                    │
├─────────────────────────────────────────────────────────────┤
│ CUSTOM INTEGRATION:                                     │
│ • ERP Integration                                      │
│ • Accounting Integration                               │
│ • CRM Integration                                      │
│ • HRIS Integration                                     │
│ • API Integration                                      │
│ • Third-Party Integration                              │
│ • Custom API                                           │
│ • Legacy System Integration                            │
├─────────────────────────────────────────────────────────────┤
│ INFRASTRUCTURE:                                         │
│ • On-Premise Option                                    │
│ • Private Cloud                                        │
│ • Dedicated Infrastructure                             │
│ • Custom Deployment                                    │
│ • Data Migration                                       │
├─────────────────────────────────────────────────────────────┤
│ SECURITY:                                               │
│ • Custom Security Policy                               │
│ • Advanced Access Control                              │
│ • Custom Audit Requirement                             │
│ • Custom Compliance Requirement                        │
│ • Custom SLA                                           │
├─────────────────────────────────────────────────────────────┤
│ SERVICE:                                                │
│ • Dedicated Account Manager                             │
│ • Dedicated Technical Support                           │
│ • Training                                              │
│ • Onboarding                                            │
│ • Implementation Assistance                             │
│ • Data Migration Assistance                             │
│ • White-Label Option                                    │
│ • Custom Contract                                       │
│ • AI Custom                                             │
└─────────────────────────────────────────────────────────────┘
`;
  };

  // ─── SPEECH RECOGNITION ──────────────────────────────────────
  useEffect(() => {
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      recognitionRef.current = new SpeechRecognition();
      recognitionRef.current.lang = 'id-ID';
      recognitionRef.current.continuous = true;
      recognitionRef.current.interimResults = true;

      recognitionRef.current.onresult = (event) => {
        let finalTranscript = '';
        let interimTranscript = '';

        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            finalTranscript += transcript;
          } else {
            interimTranscript += transcript;
          }
        }

        if (interimTranscript) {
          setInput(interimTranscript);
          setVoiceCommand(interimTranscript);
          setIsVoiceTabActive(true);
          lastTranscriptRef.current = interimTranscript;

          if (autoProcessTimerRef.current) {
            clearTimeout(autoProcessTimerRef.current);
          }
        }

        if (finalTranscript) {
          setInput(finalTranscript);
          setVoiceCommand(finalTranscript);
          lastTranscriptRef.current = finalTranscript;

          if (silenceTimerRef.current) {
            clearTimeout(silenceTimerRef.current);
          }
          if (autoProcessTimerRef.current) {
            clearTimeout(autoProcessTimerRef.current);
          }

          autoProcessTimerRef.current = setTimeout(() => {
            const textToProcess = finalTranscript.trim() || lastTranscriptRef.current.trim();
            if (textToProcess) {
              setIsAutoProcessing(true);
              handleSend(textToProcess);
              setVoiceCommand('');
              setShowVoiceMode(false);
              setActiveTab('chat');
              setIsVoiceTabActive(false);
              setIsAutoProcessing(false);
              setInput('');
              lastTranscriptRef.current = '';
            }
          }, 2000);
        }
      };

      recognitionRef.current.onend = () => {
        setIsListening(false);
        setIsProcessingVoice(false);
        setIsVoiceTabActive(false);
        if (input.trim() && !loading && !isAutoProcessing) {
          handleSend(input);
        }
      };

      recognitionRef.current.onerror = (event) => {
        console.error('Speech Recognition Error:', event.error);
        setIsListening(false);
        setIsProcessingVoice(false);
        setIsVoiceTabActive(false);
        if (event.error === 'not-allowed') {
          alert('⚠️ Mohon izinkan akses mikrofon di browser Anda.');
        }
      };
    }

    return () => {
      if (recognitionRef.current) {
        recognitionRef.current.abort();
      }
      if (silenceTimerRef.current) {
        clearTimeout(silenceTimerRef.current);
      }
      if (autoProcessTimerRef.current) {
        clearTimeout(autoProcessTimerRef.current);
      }
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  // ─── TEXT TO SPEECH ──────────────────────────────────────────
  const speakText = async (text) => {
    // ─── HANYA BICARA JIKA voiceEnabled = true ────────────────
    if (!voiceEnabled) return;
    if (!text || text.trim().length === 0) return;

    if (ELEVENLABS_API_KEY) {
      try {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current = null;
        }

        setIsSpeaking(true);
        setActiveTab('speaking');

        const response = await fetch(ELEVENLABS_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'xi-api-key': ELEVENLABS_API_KEY
          },
          body: JSON.stringify({
            text: text,
            model_id: 'eleven_monolingual_v1',
            voice_settings: {
              stability: 0.5,
              similarity_boost: 0.75,
              style: 0.3,
              use_speaker_boost: true
            }
          })
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('ElevenLabs Error:', response.status, errorText);
          throw new Error('ElevenLabs API Error');
        }

        const audioBlob = await response.blob();
        const audioUrl = URL.createObjectURL(audioBlob);

        const audio = new Audio(audioUrl);
        audioRef.current = audio;

        audio.onended = () => {
          setIsSpeaking(false);
          setActiveTab('chat');
          URL.revokeObjectURL(audioUrl);
          audioRef.current = null;
        };

        audio.onerror = (e) => {
          console.error('Audio play error:', e);
          setIsSpeaking(false);
          setActiveTab('chat');
          speakWithBrowser(text);
        };

        await audio.play();

      } catch (error) {
        console.warn('ElevenLabs error, fallback to browser:', error);
        speakWithBrowser(text);
      }
    } else {
      speakWithBrowser(text);
    }
  };

  // ─── FALLBACK: BROWSER SPEECH ───────────────────────────────
  const speakWithBrowser = (text) => {
    if (!window.speechSynthesis) return;

    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'id-ID';
    utterance.rate = 0.9;
    utterance.pitch = 1.1;
    utterance.volume = 1;

    const voices = window.speechSynthesis.getVoices();
    const preferredVoices = [
      voices.find(v => v.lang === 'id-ID' && v.name.includes('Google')),
      voices.find(v => v.lang === 'id-ID' && v.name.includes('Microsoft')),
      voices.find(v => v.lang === 'id-ID' && v.name.includes('Samantha')),
      voices.find(v => v.lang === 'id-ID'),
      voices.find(v => v.lang.startsWith('id')),
    ];
    const indonesianVoice = preferredVoices.find(v => v !== undefined);
    if (indonesianVoice) {
      utterance.voice = indonesianVoice;
    }

    utterance.onstart = () => {
      setIsSpeaking(true);
      setActiveTab('speaking');
    };
    utterance.onend = () => {
      setIsSpeaking(false);
      setActiveTab('chat');
    };
    utterance.onerror = () => {
      setIsSpeaking(false);
      setActiveTab('chat');
    };

    window.speechSynthesis.speak(utterance);
  };

  // ─── STOP SPEAKING ────────────────────────────────────────────
  const stopSpeaking = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }

    if (window.speechSynthesis && window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }

    setIsSpeaking(false);
    setActiveTab('chat');

    const stopMessage = {
      id: Date.now(),
      role: 'assistant',
      content: `⏹️ Suara dihentikan. Silakan lanjutkan dengan pertanyaan lain.`,
      timestamp: new Date().toLocaleTimeString()
    };
    setMessages(prev => [...prev, stopMessage]);
  };

  // ─── TOGGLE VOICE ─────────────────────────────────────────────
  const toggleVoice = () => {
    setVoiceEnabled(!voiceEnabled);
    if (voiceEnabled) {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
      if (window.speechSynthesis && window.speechSynthesis.speaking) {
        window.speechSynthesis.cancel();
      }
      setIsSpeaking(false);
      setActiveTab('chat');
    }
  };

  // ─── NAVIGASI HALAMAN ─────────────────────────────────────────
  const navigateToPage = (pageType) => {
    const sectionMap = {
      'pricing': 'harga',
      'features': 'fitur',
      'jobs': 'loker',
      'register': 'beranda',
      'tips': 'beranda',
      'corporate': 'harga',
      'promo': 'beranda',
      'help': 'beranda',
      'hr': 'tentang',
      'about': 'tentang',
      'contact': 'kontak',
      'login': 'beranda'
    };

    const section = sectionMap[pageType] || 'beranda';
    const element = document.getElementById(section);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setShowPagePreview(pageType);

      const navMessage = {
        id: Date.now(),
        role: 'assistant',
        content: `📄 Membuka halaman ${section}... Menampilkan informasi yang Anda cari.`,
        timestamp: new Date().toLocaleTimeString()
      };
      setMessages(prev => [...prev, navMessage]);
    } else {
      const fallbackMessage = {
        id: Date.now(),
        role: 'assistant',
        content: `📄 Halaman ${section} sedang dalam pengembangan. Silakan cek menu navigasi di atas.`,
        timestamp: new Date().toLocaleTimeString()
      };
      setMessages(prev => [...prev, fallbackMessage]);
    }
  };

  // ─── QUICK REPLY BUTTONS ──────────────────────────────────────
  const quickReplies = [
    { label: 'Harga', icon: 'mdi:tag-outline' },
    { label: 'Fitur', icon: 'mdi:puzzle-outline' },
    { label: 'Daftar', icon: 'mdi:account-plus-outline' },
    { label: 'Loker', icon: 'mdi:briefcase-search-outline' },
    { label: 'Tips', icon: 'mdi:lightbulb-on-outline' },
    { label: 'Corporate', icon: 'mdi:office-building-outline' },
    { label: 'Promo', icon: 'mdi:gift-outline' },
    { label: 'Bantuan', icon: 'mdi:help-circle-outline' },
  ];

  // ─── WELCOME MESSAGE ──────────────────────────────────────────
  useEffect(() => {
    if (messages.length === 0) {
      setMessages([
        {
          id: 1,
          role: 'assistant',
          content: `👋 Halo! Saya asisten AI ZENTRA.

💬 **Assistant Website AI**

Buka halaman, cari data, dan jalankan perintah melalui chat atau suara.

Tanyakan tentang:
• 💰 Harga & Paket Langganan
• ✨ Fitur ZENTRA
• 📝 Cara Daftar
• 💼 Info Loker
• 💡 Tips Karier
• 🏢 Corporate
• 🎁 Promo
• 📞 Bantuan`,
          timestamp: new Date().toLocaleTimeString()
        }
      ]);
    }
  }, []);

  // ─── SCROLL TO BOTTOM ─────────────────────────────────────────
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  // ─── FOCUS INPUT ──────────────────────────────────────────────
  useEffect(() => {
    if (isOpen && inputRef.current && !isListening) {
      setTimeout(() => inputRef.current.focus(), 300);
    }
  }, [isOpen, isListening]);

  // ─── DETECT PAGE TYPE ─────────────────────────────────────────
  const detectPageType = (message) => {
    const msg = message.toLowerCase();
    if (msg.includes('harga') || msg.includes('paket') || msg.includes('langganan') || msg.includes('biaya') || msg.includes('price')) {
      return 'pricing';
    }
    if (msg.includes('fitur') || msg.includes('feature') || msg.includes('apa saja') || msg.includes('fasilitas')) {
      return 'features';
    }
    if (msg.includes('loker') || msg.includes('lowongan') || msg.includes('kerja') || msg.includes('job') || msg.includes('posisi')) {
      return 'jobs';
    }
    if (msg.includes('daftar') || msg.includes('register') || msg.includes('cara') || msg.includes('sign up')) {
      return 'register';
    }
    if (msg.includes('tips') || msg.includes('karir') || msg.includes('cv') || msg.includes('interview') || msg.includes('career')) {
      return 'tips';
    }
    if (msg.includes('corporate') || msg.includes('perusahaan besar') || msg.includes('enterprise')) {
      return 'corporate';
    }
    if (msg.includes('promo') || msg.includes('diskon') || msg.includes('discount')) {
      return 'promo';
    }
    if (msg.includes('bantuan') || msg.includes('help') || msg.includes('kontak') || msg.includes('support')) {
      return 'help';
    }
    if (msg.includes('karyawan') || msg.includes('hr') || msg.includes('employee') || msg.includes('staff')) {
      return 'hr';
    }
    if (msg.includes('tentang') || msg.includes('about') || msg.includes('profil') || msg.includes('company')) {
      return 'about';
    }
    return null;
  };

  // ─── SYSTEM PROMPT ────────────────────────────────────────────
  const getSystemPrompt = () => `
Anda adalah **ZENTRA AI - Public Website Assistant**.

🎯 SCOPE ANDA:
Anda adalah asisten publik untuk website ZENTRA. Anda HANYA bisa menjawab pertanyaan tentang:
1. Informasi ZENTRA (profil, visi, misi, target pasar)
2. Produk & Fitur ZENTRA
3. Harga & Paket Langganan
4. Lowongan Kerja
5. Informasi untuk Perusahaan & Pencari Kerja
6. Navigasi Website

🚫 BATASAN ANDA:
Anda TIDAK BISA mengakses data internal perusahaan seperti data karyawan, absensi, payroll, dll.

📚 KNOWLEDGE BASE:
ZENTRA adalah platform HR Management System #1 di Indonesia.

${getPricingKnowledge()}

FITUR UNGGULAN:
- Rekrutmen Terintegrasi
- Manajemen Karyawan
- AI Screening Otomatis
- Payroll & Gaji
- Analytics & Laporan
- Absensi & Cuti Online
- Mobile App
- API Access (Enterprise)

LOWONGAN KERJA:
- Frontend Developer - Jakarta
- Backend Engineer - Jakarta
- Product Manager - Jakarta
- UI/UX Designer - Remote
- Data Analyst - Jakarta
- HR Business Partner - Jakarta

🎯 PERSONALITY:
- Ramah, hangat, dan profesional
- Gunakan bahasa Indonesia yang natural
- Jelaskan dengan analogi sederhana

🗣️ RESPONS FORMAT:
- Jawab dengan paragraf pendek
- Gunakan bullet points dengan • atau -
- JANGAN gunakan markdown (#, **, ---, |)
- Tawarkan bantuan lanjutan di akhir
`;

  // ─── GET AI RESPONSE ──────────────────────────────────────────
  const getAIResponse = async (userMessage) => {
    const pageType = detectPageType(userMessage);
    setShowPagePreview(pageType);

    if (pageType) {
      navigateToPage(pageType);
    }

    if (!DEEPSEEK_API_KEY) {
      return getLocalResponse(userMessage, pageType);
    }

    try {
      const response = await fetch(AI_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${DEEPSEEK_API_KEY}`
        },
        body: JSON.stringify({
          model: 'deepseek-chat',
          messages: [
            { role: 'system', content: getSystemPrompt() },
            ...messages.slice(-5).map(m => ({ role: m.role, content: m.content })),
            { role: 'user', content: userMessage }
          ],
          temperature: 0.3,
          max_tokens: 800,
        })
      });

      if (!response.ok) {
        throw new Error('API Error');
      }

      const data = await response.json();
      return data.choices[0].message.content;

    } catch (error) {
      console.error('DeepSeek Error:', error);
      return getLocalResponse(userMessage, pageType);
    }
  };

  // ─── LOCAL RESPONSE ───────────────────────────────────────────
  const getLocalResponse = (message, pageType) => {
    const msg = message.toLowerCase();

    if (msg.includes('data karyawan') || msg.includes('absensi') || msg.includes('payroll') ||
        msg.includes('slip gaji') || msg.includes('cuti') || msg.includes('gaji saya')) {
      return `🙏 Maaf, untuk mengakses data tersebut Anda perlu login terlebih dahulu.

Saat ini saya adalah asisten publik ZENTRA yang bisa membantu informasi tentang produk, harga, dan lowongan kerja.

Mau saya bantu dengan informasi lain? 😊`;
    }

    if (msg.includes('harga') || msg.includes('paket') || msg.includes('biaya') || msg.includes('langganan')) {
      return `💼 PAKET ZENTRA LENGKAP:

╔══════════════════════════════════════════════════════════════╗
║ BASIC - Rp1.500.000/bulan                                   ║
║ Untuk startup & UMKM                                       ║
╠══════════════════════════════════════════════════════════════╣
║ KAPASITAS: 3 User Admin, 50 Karyawan, 1 Perusahaan         ║
║ REKRUTMEN: Dashboard, Lowongan (50 posting), Kandidat,     ║
║   Lamaran Online, Tes Online, Interview, Offering & Hiring ║
║ AI: Screening 75 CV/hari, HR Assistant 30 prompt/hari      ║
║ MANAJEMEN: Data Pegawai, Shift, Absensi, Selfie, Cuti,    ║
║   Payroll, Slip Gaji, Laporan HR                          ║
║ SUPPORT: Email/Chat WhatsApp, Help Center                 ║
╚══════════════════════════════════════════════════════════════╝

╔══════════════════════════════════════════════════════════════╗
║ PROFESSIONAL - Rp2.700.000/bulan ⭐ PALING POPULER          ║
║ Untuk perusahaan menengah                                  ║
╠══════════════════════════════════════════════════════════════╣
║ KAPASITAS: 10 User Admin, 300 Karyawan, 1 Perusahaan       ║
║ + Semua fitur BASIC                                        ║
║ REKRUTMEN: UNLIMITED Job Posting                           ║
║ AI: Screening 200 CV/hari, HR Assistant 75 prompt/hari     ║
║ FINANCE BASIC: Dashboard, Pendapatan, Pengeluaran,         ║
║   Cash Flow, Invoice, Budget Dasar                         ║
║ MARKETING BASIC: Dashboard, Campaign, Lead Management,     ║
║   Content Planning, Social Media                           ║
║ SUPPORT: Priority Support, Email & Chat                    ║
╚══════════════════════════════════════════════════════════════╝

╔══════════════════════════════════════════════════════════════╗
║ ENTERPRISE - Rp6.300.000/bulan                             ║
║ Untuk korporasi besar                                      ║
╠══════════════════════════════════════════════════════════════╣
║ KAPASITAS: UNLIMITED Admin & Karyawan, 3 Company           ║
║ + Semua fitur Professional                                 ║
║ AI: Screening 500 CV/hari, HR Assistant 300 prompt/hari    ║
║ MANAJEMEN ENTERPRISE: Performance, KPI, Career Dev,        ║
║   Training, HR Analytics, Audit Log                        ║
║ FINANCE ENTERPRISE: Budget Management, Account Receivable, ║
║   Account Payable, Multi-Account/Branch/Company            ║
║ MARKETING ENTERPRISE: Campaign Budget, Conversion Tracking,║
║   Marketing Analytics, ROI, Approval Workflow              ║
║ SECURITY: Advanced Role & Permission, Enterprise Security  ║
║ SUPPORT: Dedicated Support, Priority Technical, SLA 99.9%  ║
╚══════════════════════════════════════════════════════════════╝

╔══════════════════════════════════════════════════════════════╗
║ CUSTOM / CORPORATE - Custom Pricing                        ║
║ Untuk korporasi dan kebutuhan khusus                       ║
╠══════════════════════════════════════════════════════════════╣
║ + Semua fitur Enterprise                                   ║
║ CUSTOM MODULE: Custom Dashboard, Workflow, Report,         ║
║   Approval, Role, Permission                               ║
║ CUSTOM INTEGRATION: ERP, Accounting, CRM, HRIS, API,      ║
║   Third-Party, Legacy System                              ║
║ INFRASTRUCTURE: On-Premise, Private Cloud, Custom         ║
║ SECURITY: Custom Security Policy, Custom SLA              ║
║ SERVICE: Dedicated Account Manager, Training, Onboarding, ║
║   White-Label, Custom Contract, AI Custom                 ║
╚══════════════════════════════════════════════════════════════╝

💡 Semua paket termasuk trial 14 hari gratis!
Mau saya bukakan halaman harga biar Anda lihat perbandingannya?`;
    }

    if (msg.includes('fitur') || msg.includes('feature') || msg.includes('apa saja')) {
      return `✨ FITUR LENGKAP ZENTRA PER PAKET:

📌 BASIC (Rp1.500.000/bulan):
• 3 Admin, 50 Karyawan
• AI Screening 75 CV/hari
• AI HR Assistant 30 prompt/hari
• Recruitment Dasar + Employee Management
• Attendance & Payroll + HR Reports

📌 PROFESSIONAL (Rp2.700.000/bulan) ⭐:
• 10 Admin, 300 Karyawan
• AI Screening 200 CV/hari
• AI HR Assistant 75 prompt/hari
• Unlimited Job Posting
• Finance Basic + Marketing Basic
• Priority Support

📌 ENTERPRISE (Rp6.300.000/bulan):
• Unlimited Admin & Karyawan
• AI Screening 500 CV/hari
• AI HR Assistant 300 prompt/hari
• Performance & KPI Management
• Advanced Finance & Marketing
• Multi-Branch & Multi-Company
• API Access + Dedicated Support
• SLA 99.9%

📌 CUSTOM (Custom Pricing):
• Semua fitur Enterprise
• Custom Module & Integration
• On-Premise Option
• White-Label Option
• Dedicated Account Manager

Mau saya bukakan halaman fitur biar Anda lihat detailnya?`;
    }

    if (msg.includes('loker') || msg.includes('lowongan') || msg.includes('kerja') || msg.includes('job')) {
      return `💼 Lowongan Kerja ZENTRA:

Frontend Developer – Jakarta
• React/Vue, HTML, CSS, JavaScript

Backend Engineer – Jakarta
• Node.js/Python, Database, REST API

Product Manager – Jakarta
• Agile, Product Strategy, Analytics

UI/UX Designer – Remote
• Figma, Design System, Research

Data Analyst – Jakarta
• SQL, Python, Tableau, Power BI

HR Business Partner – Jakarta
• People Development, Strategy, HR

📌 Cek halaman Loker untuk detail lengkap!
Atau mau saya bantu cari posisi tertentu?`;
    }

    if (msg.includes('daftar') || msg.includes('register') || msg.includes('cara') || msg.includes('sign up')) {
      return `📝 Cara Daftar ZENTRA:

1. Klik "Mulai Gratis" di website
2. Isi data perusahaan Anda
3. Verifikasi email
4. Trial 14 hari gratis!

💡 Tidak perlu kartu kredit!
Mau saya bantu arahkan ke halaman pendaftaran?`;
    }

    if (msg.includes('karyawan') || msg.includes('hr') || msg.includes('employee') || msg.includes('staff')) {
      return `👥 Manajemen Karyawan ZENTRA:

ZENTRA membantu perusahaan mengelola karyawan dengan:
✅ Database terpusat
✅ Tracking kehadiran
✅ Cuti online
✅ Evaluasi performa
✅ Payroll otomatis

📌 Fitur ini membantu HR mengelola karyawan dengan lebih efisien!

Maaf, untuk melihat data karyawan spesifik, Anda perlu login terlebih dahulu karena itu data internal perusahaan.`;
    }

    if (msg.includes('tentang') || msg.includes('about') || msg.includes('profil') || msg.includes('company')) {
      return `🏢 Tentang ZENTRA:

ZENTRA adalah platform HR Management System #1 di Indonesia yang menghubungkan kebutuhan perusahaan dan pencari kerja.

VISI: Menjadi platform HR #1 di Indonesia yang terpercaya dan inovatif.

MISI: Membantu perusahaan mengelola SDM dengan lebih cerdas dan efisien.

TARGET: Perusahaan dari berbagai skala (UMKM hingga Korporasi) dan pencari kerja.

Mau tahu lebih lanjut tentang fitur atau harga?`;
    }

    if (msg.includes('tips') || msg.includes('karir') || msg.includes('cv') || msg.includes('interview') || msg.includes('career')) {
      return `💡 Tips Karier:

📄 CV ATS-Friendly: Format sederhana, fokus pencapaian, hindari gambar/chart

🎯 Persiapan Interview: Riset perusahaan, latih jawaban, siapkan pertanyaan

💰 Negosiasi Gaji: Ketahui nilai pasar, sampaikan ekspektasi dengan percaya diri

📈 Pengembangan Karir: Ikuti pelatihan, bangun network, minta feedback!

Ada yang mau ditanyakan lebih lanjut?`;
    }

    if (msg.includes('corporate') || msg.includes('perusahaan besar') || msg.includes('enterprise')) {
      return `🏢 PAKET CORPORATE & ENTERPRISE:

ENTERPRISE - Rp6.300.000/bulan
✅ Unlimited Admin & Karyawan
✅ 3 Company
✅ AI Screening 500 CV/hari
✅ AI HR Assistant 300 prompt/hari
✅ Performance & KPI Management
✅ Advanced Finance (Multi-Account/Branch)
✅ Advanced Marketing (Campaign ROI)
✅ API Access
✅ Dedicated Support
✅ SLA 99.9%

CUSTOM - Custom Pricing
✅ Semua fitur Enterprise
✅ Custom Module & Dashboard
✅ Custom Workflow & Report
✅ Custom Integration (ERP, CRM, HRIS)
✅ On-Premise Option
✅ Private Cloud
✅ White-Label Option
✅ Dedicated Account Manager
✅ Custom SLA & Security Policy

📞 Hubungi sales untuk info lebih lanjut!`;
    }

    if (msg.includes('promo') || msg.includes('diskon') || msg.includes('discount')) {
      return `🎉 Promo ZENTRA:

💥 Diskon 20% untuk pembayaran tahunan!
🔥 Promo terbatas!

📞 Hubungi sales untuk info lebih lanjut.
Mau saya bantu hubungkan dengan tim sales?`;
    }

    if (msg.includes('bantuan') || msg.includes('help') || msg.includes('kontak') || msg.includes('support')) {
      return `📞 Hubungi Kami:

📧 Email: support@zentra.com
📱 Telepon: 021-1234-5678
💬 WhatsApp: 0812-3456-7890

🌐 Website: https://golife.my.id
🕐 Jam Operasional: 08:00-17:00 WIB

Ada yang bisa saya bantu?`;
    }

    return `Terima kasih atas pertanyaannya! 🙏

Saya asisten AI ZENTRA. Saya bisa bantu tentang:
• 💰 Harga & Paket Langganan
• ✨ Fitur ZENTRA
• 📝 Cara Daftar
• 💼 Info Loker
• 💡 Tips Karier
• 🏢 Corporate
• 🎁 Promo
• 📞 Bantuan

Atau mau saya bukakan halaman tertentu? Silakan pilih topik di bawah! 😊`;
  };

  // ─── HANDLE SEND ──────────────────────────────────────────────
  const handleSend = async (textToSend) => {
    const messageToSend = textToSend || input;
    if (!messageToSend.trim()) return;

    const userMessage = {
      id: Date.now(),
      role: 'user',
      content: messageToSend.trim(),
      timestamp: new Date().toLocaleTimeString()
    };

    setMessages(prev => [...prev, userMessage]);
    const currentInput = messageToSend.trim();
    setInput('');
    setVoiceCommand('');
    setShowVoiceMode(false);
    setLoading(true);

    try {
      const aiResponse = await getAIResponse(currentInput);

      const pageType = detectPageType(currentInput);
      setShowPagePreview(pageType);

      if (pageType && ['pricing', 'features', 'jobs', 'register', 'about', 'hr'].includes(pageType)) {
        navigateToPage(pageType);
      }

      const cleanResponse = aiResponse
        .replace(/\*\*/g, '')
        .replace(/\#/g, '')
        .replace(/\-\-\-/g, '')
        .replace(/\|/g, '')
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
        .replace(/\_/g, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim();

      const aiMessage = {
        id: Date.now() + 1,
        role: 'assistant',
        content: cleanResponse,
        timestamp: new Date().toLocaleTimeString()
      };

      setMessages(prev => [...prev, aiMessage]);

      // ─── SUARA HANYA JIKA voiceEnabled = true ──────────────
      if (voiceEnabled) {
        const cleanText = cleanResponse
          .replace(/\*\*/g, '')
          .replace(/[•\-]/g, '')
          .replace(/\n/g, '. ')
          .replace(/\s+/g, ' ')
          .trim();
        await speakText(cleanText);
      }

    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  // ─── HANDLE VOICE TOGGLE ─────────────────────────────────────
  const handleVoiceToggle = () => {
    if (isListening) {
      recognitionRef.current?.stop();
      setIsListening(false);
      setIsProcessingVoice(false);
      setShowVoiceMode(false);
      setActiveTab('chat');
      setIsVoiceTabActive(false);
      setVoiceEnabled(false);
      if (silenceTimerRef.current) {
        clearTimeout(silenceTimerRef.current);
      }
      if (autoProcessTimerRef.current) {
        clearTimeout(autoProcessTimerRef.current);
      }
      if (input.trim()) {
        handleSend(input);
      }
      return;
    }

    if (!recognitionRef.current) {
      alert('❌ Browser Anda tidak mendukung input suara!\n\n📌 Gunakan Google Chrome atau Microsoft Edge.\n📌 Pastikan izin mikrofon diberikan.');
      return;
    }

    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(() => {
        setIsListening(true);
        setIsProcessingVoice(true);
        setShowVoiceMode(true);
        setActiveTab('speaking');
        setIsVoiceTabActive(true);
        setVoiceEnabled(true); // ← AKTIFKAN VOICE
        setVoiceCommand('Mendengarkan...');
        recognitionRef.current.start();

        const voiceMessage = {
          id: Date.now(),
          role: 'assistant',
          content: `🎤 Mode suara diaktifkan. Anda bisa bicara untuk memberi perintah. Otomatis diproses 2 detik setelah diam.`,
          timestamp: new Date().toLocaleTimeString()
        };
        setMessages(prev => [...prev, voiceMessage]);
      })
      .catch((err) => {
        alert(`❌ Tidak dapat mengakses mikrofon!\n\nError: ${err.message}\n\n📌 Pastikan izin mikrofon diberikan.`);
      });
  };

  // ─── HANDLE QUICK REPLY ──────────────────────────────────────
  const handleQuickReply = (label) => {
    setInput(label);
    setTimeout(() => {
      handleSend(label);
    }, 200);
  };

  // ─── HANDLE KEY PRESS ──────────────────────────────────────────
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend(input);
    }
  };

  // ─── RENDER ──────────────────────────────────────────────────
  return (
    <>
      <div className="fixed bottom-4 right-4 z-50">
        {isOpen && (
          <div className="w-[420px] max-w-[calc(100vw-2rem)] bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden flex flex-col h-[min(580px,calc(100vh-90px))] mb-3">

            {/* ─── HEADER ────────────────────────────────────────── */}
            <div className="bg-gradient-to-r from-zentra-600 to-zentra-700 px-4 py-3 flex items-center justify-between flex-shrink-0">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center border border-white/10">
                  <Icon icon="mdi:robot" className="text-white text-lg" />
                </div>
                <div>
                  <h3 className="text-sm font-bold text-white tracking-wide">ZENTRA AI</h3>
                  <p className="text-[10px] text-white/70 flex items-center gap-1">
                    <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse inline-block"></span>
                    {isListening ? '🎤 Mendengar...' : isSpeaking ? '🔊 Berbicara...' : voiceEnabled ? '🔊 Suara ON' : 'Online'}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <button
                  onClick={handleVoiceToggle}
                  className={`p-1.5 rounded-lg transition-all ${
                    isListening
                      ? 'bg-red-500/30 text-red-400 animate-pulse'
                      : voiceEnabled
                      ? 'bg-emerald-500/30 text-emerald-400'
                      : 'text-white/70 hover:text-white hover:bg-white/10'
                  }`}
                  title={isListening ? 'Hentikan rekaman' : voiceEnabled ? 'Suara ON' : 'Aktifkan suara'}
                >
                  <Icon
                    icon={isListening ? 'mdi:microphone-off' : voiceEnabled ? 'mdi:volume-high' : 'mdi:volume-off'}
                    className="text-base"
                  />
                </button>
                {isSpeaking && (
                  <button
                    onClick={stopSpeaking}
                    className="p-1.5 rounded-lg bg-red-500/30 text-white hover:bg-red-500/50 transition-colors animate-pulse"
                    title="Hentikan suara AI"
                  >
                    <Icon icon="mdi:stop-circle" className="text-base" />
                  </button>
                )}
                <button
                  onClick={() => setIsOpen(false)}
                  className="p-1.5 rounded-lg text-white/70 hover:text-white hover:bg-white/10 transition-colors"
                >
                  <Icon icon="mdi:close" className="text-base" />
                </button>
              </div>
            </div>

            {/* ─── TAB ───────────────────────────────────────────── */}
            <div className="flex border-b border-gray-100 flex-shrink-0 bg-gray-50">
              <button
                onClick={() => {
                  setActiveTab('chat');
                  setIsVoiceTabActive(false);
                  setVoiceEnabled(false);
                  if (isListening) {
                    recognitionRef.current?.stop();
                    setIsListening(false);
                    setIsProcessingVoice(false);
                    setShowVoiceMode(false);
                  }
                }}
                className={`flex-1 px-3 py-1.5 text-[10px] font-medium transition-all ${
                  activeTab === 'chat' && !isVoiceTabActive
                    ? 'text-zentra-600 border-b-2 border-zentra-600 bg-white'
                    : 'text-gray-400 hover:text-gray-600'
                }`}
              >
                💬 Chat
              </button>
              <button
                onClick={() => {
                  setActiveTab('speaking');
                  setIsVoiceTabActive(true);
                  setVoiceEnabled(true);
                  if (!isListening) {
                    handleVoiceToggle();
                  }
                }}
                className={`flex-1 px-3 py-1.5 text-[10px] font-medium transition-all ${
                  isVoiceTabActive || activeTab === 'speaking'
                    ? 'text-zentra-600 border-b-2 border-zentra-600 bg-white'
                    : 'text-gray-400 hover:text-gray-600'
                }`}
              >
                🎤 Berbicara
              </button>
            </div>

            {/* ─── CONTENT ───────────────────────────────────────── */}
            {isVoiceTabActive ? (
              // ─── VOICE MODE PREMIUM ──────────────────────────────
              <div className="flex-1 flex flex-col items-center justify-center p-6 bg-gradient-to-b from-zentra-50 to-white">
                <div className="text-center">

                  {/* ─── AVATAR BULAT DENGAN WAVE ────────────────── */}
                  <div className="relative mx-auto mb-6">
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className={`absolute w-32 h-32 rounded-full border-2 border-zentra-400/30 transition-all duration-700 ${
                        isListening || loading || isSpeaking
                          ? 'scale-100 opacity-100'
                          : 'scale-50 opacity-0'
                      }`}>
                        <div className={`w-full h-full rounded-full border-t-2 animate-spin-slow ${
                          isListening ? 'border-t-zentra-500' : loading ? 'border-t-amber-500' : 'border-t-emerald-500'
                        }`}></div>
                      </div>
                    </div>

                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className={`absolute w-40 h-40 rounded-full border-2 border-zentra-400/20 transition-all duration-700 delay-150 ${
                        isListening || loading || isSpeaking
                          ? 'scale-100 opacity-100'
                          : 'scale-50 opacity-0'
                      }`}>
                        <div className={`w-full h-full rounded-full border-t-2 animate-spin-slow-reverse ${
                          isListening ? 'border-t-zentra-400' : loading ? 'border-t-amber-400' : 'border-t-emerald-400'
                        }`}></div>
                      </div>
                    </div>

                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className={`absolute w-48 h-48 rounded-full border-2 border-zentra-400/10 transition-all duration-700 delay-300 ${
                        isListening || loading || isSpeaking
                          ? 'scale-100 opacity-100'
                          : 'scale-50 opacity-0'
                      }`}>
                        <div className={`w-full h-full rounded-full border-t-2 animate-spin-slow ${
                          isListening ? 'border-t-zentra-300' : loading ? 'border-t-amber-300' : 'border-t-emerald-300'
                        }`}></div>
                      </div>
                    </div>

                    <div className={`absolute inset-0 flex items-center justify-center transition-all duration-500 ${
                      isListening || loading || isSpeaking ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
                    }`}>
                      <div className="flex items-center gap-1 h-12">
                        {[...Array(10)].map((_, i) => (
                          <div
                            key={i}
                            className={`w-1.5 rounded-full transition-all duration-300 ${
                              isListening ? 'bg-zentra-500 animate-wave'
                                : loading ? 'bg-amber-500 animate-wave'
                                : isSpeaking ? 'bg-emerald-500 animate-wave'
                                : 'bg-gray-300 h-2'
                            }`}
                            style={{
                              height: isListening || loading || isSpeaking
                                ? `${4 + Math.random() * 16}px`
                                : '8px',
                              animationDelay: `${i * 0.08}s`,
                              animationDuration: `${0.6 + Math.random() * 0.4}s`
                            }}
                          ></div>
                        ))}
                      </div>
                    </div>

                    <div className={`relative z-10 w-24 h-24 rounded-full mx-auto flex items-center justify-center transition-all duration-500 ${
                      isListening
                        ? 'bg-gradient-to-br from-zentra-500 to-zentra-700 shadow-2xl shadow-zentra-500/40 scale-105'
                        : loading
                        ? 'bg-gradient-to-br from-amber-500 to-orange-600 shadow-2xl shadow-amber-500/40 scale-105'
                        : isSpeaking
                        ? 'bg-gradient-to-br from-emerald-500 to-teal-600 shadow-2xl shadow-emerald-500/40 scale-105'
                        : 'bg-gradient-to-br from-zentra-400 to-zentra-600 shadow-lg shadow-zentra-500/20'
                    }`}>
                      <Icon
                        icon={isListening ? 'mdi:microphone' : loading ? 'mdi:loading' : isSpeaking ? 'mdi:volume-high' : 'mdi:robot-happy'}
                        className={`text-4xl text-white transition-all duration-500 ${loading ? 'animate-spin' : ''}`}
                      />
                    </div>

                    <div className={`absolute -top-1 -right-1 z-20 w-4 h-4 rounded-full transition-all duration-300 ${
                      isListening ? 'bg-red-500 animate-pulse'
                        : loading ? 'bg-amber-500 animate-pulse'
                        : isSpeaking ? 'bg-emerald-500 animate-pulse'
                        : 'bg-green-500'
                    }`}>
                      <div className={`absolute inset-0 rounded-full transition-all duration-300 ${
                        isListening || loading || isSpeaking ? 'animate-ping opacity-75' : 'opacity-0'
                      } ${
                        isListening ? 'bg-red-500' : loading ? 'bg-amber-500' : 'bg-emerald-500'
                      }`}></div>
                    </div>
                  </div>

                  <p className={`text-sm font-semibold transition-all duration-300 ${
                    isListening ? 'text-red-600' : loading ? 'text-amber-600' : isSpeaking ? 'text-emerald-600' : 'text-gray-800'
                  }`}>
                    {isListening ? '🎤 Mendengarkan...' : loading ? '🧠 Berpikir...' : isSpeaking ? '🔊 Berbicara...' : 'Mode suara diaktifkan'}
                  </p>

                  <p className="text-xs text-gray-500 mt-1">
                    {isListening
                      ? voiceCommand || 'Bicara dengan jelas...'
                      : loading
                      ? 'AI sedang memproses permintaan Anda...'
                      : isSpeaking
                      ? 'AI sedang menjelaskan...'
                      : 'Anda bisa bicara untuk memberi perintah'}
                  </p>

                  {voiceCommand && (isListening || loading) && (
                    <div className="mt-4 p-3 bg-white/80 backdrop-blur-sm rounded-xl border border-gray-200 max-w-xs mx-auto shadow-sm">
                      <p className="text-sm text-gray-700 font-medium truncate">
                        "{voiceCommand}"
                      </p>
                    </div>
                  )}

                  {isListening && (
                    <div className="mt-3 flex items-center justify-center gap-2">
                      <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                      <span className="text-xs text-red-500 font-medium">Merekam...</span>
                      <span className="text-xs text-gray-400">| ⏱️ 2 detik</span>
                    </div>
                  )}

                  {loading && (
                    <div className="mt-3 flex items-center justify-center gap-2">
                      <span className="w-2 h-2 bg-amber-500 rounded-full animate-pulse"></span>
                      <span className="text-xs text-amber-500 font-medium">Memproses...</span>
                      <div className="flex items-center gap-0.5">
                        {[...Array(3)].map((_, i) => (
                          <span
                            key={i}
                            className="w-1.5 h-1.5 bg-amber-500 rounded-full animate-bounce"
                            style={{ animationDelay: `${i * 0.2}s` }}
                          ></span>
                        ))}
                      </div>
                    </div>
                  )}

                  {isSpeaking && (
                    <div className="mt-3 flex items-center justify-center gap-2">
                      <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
                      <span className="text-xs text-emerald-500 font-medium">Berbicara...</span>
                    </div>
                  )}

                  <div className="mt-6 flex items-center justify-center gap-3">
                    <button
                      onClick={() => {
                        if (isListening) {
                          handleVoiceToggle();
                        } else {
                          handleVoiceToggle();
                        }
                      }}
                      className={`px-5 py-2.5 rounded-xl text-xs font-medium transition-all ${
                        isListening
                          ? 'bg-red-500 hover:bg-red-600 text-white shadow-lg shadow-red-500/30'
                          : loading || isSpeaking
                          ? 'bg-gray-400 text-white cursor-not-allowed'
                          : 'bg-zentra-600 hover:bg-zentra-700 text-white shadow-lg shadow-zentra-500/30'
                      }`}
                    >
                      {isListening ? '⏹️ Berhenti' : loading ? '⏳ Proses...' : isSpeaking ? '🔊 Berbicara...' : '🎤 Mulai Bicara'}
                    </button>

                    {isListening && (
                      <button
                        onClick={() => {
                          if (input.trim()) {
                            if (autoProcessTimerRef.current) {
                              clearTimeout(autoProcessTimerRef.current);
                            }
                            handleSend(input);
                            setIsVoiceTabActive(false);
                            setActiveTab('chat');
                          }
                        }}
                        className="px-5 py-2.5 rounded-xl text-xs font-medium bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg shadow-emerald-500/30 transition-all"
                      >
                        📤 Kirim Sekarang
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              // ─── CHAT MODE CONTENT ──────────────────────────────
              <>
                {showVoiceMode && (
                  <div className="px-3 py-1.5 bg-red-50 border-b border-red-100 flex items-center gap-2 flex-shrink-0">
                    <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
                    <span className="text-[10px] text-red-600 font-medium">🎤 Mendengarkan...</span>
                    <span className="text-[10px] text-red-500 ml-auto truncate max-w-[120px]">{voiceCommand || 'Bicara'}</span>
                  </div>
                )}

                {voiceEnabled && !isListening && !isSpeaking && (
                  <div className="px-3 py-1 bg-emerald-50 border-b border-emerald-100 flex items-center gap-2 flex-shrink-0">
                    <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"></span>
                    <span className="text-[10px] text-emerald-600 font-medium">🔊 Suara aktif</span>
                    <span className="text-[10px] text-emerald-500 ml-auto">AI akan merespons dengan suara</span>
                  </div>
                )}

                <div className="px-3 py-1 bg-gray-50 border-b border-gray-100 flex items-center justify-between flex-shrink-0">
                  {showPagePreview ? (
                    <span className="text-[9px] font-medium text-zentra-600 truncate">
                      📄 {showPagePreview === 'pricing' ? 'Harga' :
                         showPagePreview === 'features' ? 'Fitur' :
                         showPagePreview === 'jobs' ? 'Loker' :
                         showPagePreview === 'register' ? 'Daftar' :
                         showPagePreview === 'tips' ? 'Tips' :
                         showPagePreview === 'corporate' ? 'Corporate' :
                         showPagePreview === 'promo' ? 'Promo' :
                         showPagePreview === 'hr' ? 'Karyawan' :
                         showPagePreview === 'about' ? 'Tentang' : 'Bantuan'}
                    </span>
                  ) : (
                    <span className="text-[9px] text-gray-400 truncate">💬 Buka halaman, cari data, jalankan perintah</span>
                  )}
                  <span className="text-[9px] text-gray-400 flex-shrink-0 ml-2">{messages.length} pesan</span>
                </div>

                <div className="flex-1 min-h-0 overflow-y-auto p-3 space-y-1.5 bg-gray-50/50">
                  {messages.map((msg) => (
                    <div key={msg.id} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
                      <div className={`max-w-[85%] p-2 rounded-xl text-xs whitespace-pre-wrap break-words ${
                        msg.role === 'user'
                          ? 'bg-zentra-600 text-white rounded-br-none'
                          : 'bg-white border border-gray-200 text-gray-700 rounded-bl-none shadow-sm'
                      }`}>
                        {msg.content}
                        <div className="text-[8px] text-gray-400 mt-0.5">{msg.timestamp}</div>
                      </div>
                    </div>
                  ))}
                  {loading && (
                    <div className="flex justify-start">
                      <div className="bg-white border border-gray-200 p-2 rounded-xl text-gray-400 flex items-center gap-2 text-xs shadow-sm">
                        <span className="w-3 h-3 border-2 border-zentra-500 border-t-transparent rounded-full animate-spin"></span>
                        Mengetik...
                      </div>
                    </div>
                  )}
                  <div ref={messagesEndRef} />
                </div>

                <div className="px-2 py-1.5 border-t border-gray-100 bg-white flex-shrink-0">
                  <div className="flex flex-wrap gap-0.5">
                    {quickReplies.map((reply, idx) => (
                      <button
                        key={idx}
                        onClick={() => handleQuickReply(reply.label)}
                        className="text-[8px] font-medium px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 hover:bg-zentra-50 hover:text-zentra-600 transition-all flex items-center gap-0.5"
                      >
                        <Icon icon={reply.icon} className="text-[10px]" />
                        {reply.label}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="p-2 border-t border-gray-200 bg-white flex-shrink-0">
                  <div className="flex items-center gap-1.5 bg-gray-50 rounded-lg px-2 py-1 border border-gray-200 focus-within:border-zentra-300 focus-within:ring-1 focus-within:ring-zentra-100 transition-all">
                    <button
                      onClick={handleVoiceToggle}
                      className={`p-1 rounded-lg transition-all flex-shrink-0 ${
                        isListening
                          ? 'text-red-500 bg-red-50 animate-pulse'
                          : voiceEnabled
                          ? 'text-emerald-500 bg-emerald-50'
                          : 'text-gray-400 hover:text-gray-600 hover:bg-gray-200'
                      }`}
                      title={isListening ? 'Hentikan rekaman' : voiceEnabled ? 'Suara ON' : 'Aktifkan suara'}
                    >
                      <Icon
                        icon={isListening ? 'mdi:microphone-off' : voiceEnabled ? 'mdi:volume-high' : 'mdi:volume-off'}
                        className="text-base"
                      />
                    </button>

                    <input
                      ref={inputRef}
                      type="text"
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={handleKeyPress}
                      placeholder={isListening ? "🎤 Mendengarkan..." : "Ketik..."}
                      className="flex-1 px-1.5 py-0.5 bg-transparent text-gray-700 placeholder-gray-400 text-xs focus:outline-none min-w-0"
                      disabled={loading || isListening}
                    />

                    <button
                      onClick={() => handleSend(input)}
                      disabled={loading || !input.trim() || isListening}
                      className="p-1 rounded-lg bg-zentra-600 hover:bg-zentra-700 text-white transition-all disabled:opacity-40 disabled:cursor-not-allowed flex-shrink-0"
                    >
                      {loading ? (
                        <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin block"></span>
                      ) : (
                        <Icon icon="mdi:send" className="text-base" />
                      )}
                    </button>
                  </div>
                  <div className="flex justify-between mt-1 px-1">
                    <span className="text-[7px] text-gray-400 flex items-center gap-0.5">
                      <Icon icon="mdi:microphone" className="text-[8px]" /> Klik mikrofon
                    </span>
                    <div className="flex items-center gap-1">
                      <span className={`text-[7px] ${voiceEnabled ? 'text-emerald-500' : 'text-gray-400'}`}>
                        {voiceEnabled ? '🔊 Suara ON' : '🔇 Suara OFF'}
                      </span>
                      <span className="text-[7px] text-gray-400">• AI Assistant</span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`group flex items-center gap-3 px-5 py-3.5 rounded-2xl shadow-2xl transition-all duration-300 ${
            isOpen
              ? 'bg-red-500 hover:bg-red-600 text-white shadow-red-500/30'
              : 'bg-gradient-to-r from-zentra-500 via-zentra-600 to-zentra-700 hover:from-zentra-600 hover:via-zentra-700 hover:to-zentra-800 text-white shadow-zentra-500/40 hover:shadow-zentra-500/60 hover:scale-105'
          }`}
          aria-label={isOpen ? 'Tutup chat' : 'Buka chat'}
        >
          <div className={`w-10 h-10 rounded-2xl flex items-center justify-center transition-all ${
            isOpen
              ? 'bg-white/20'
              : 'bg-white/20 backdrop-blur-sm border border-white/20 group-hover:bg-white/30'
          }`}>
            <Icon
              icon={isOpen ? 'mdi:close' : 'mdi:robot-happy'}
              className="text-2xl transition-all text-white"
            />
          </div>

          <div className="flex flex-col items-start leading-tight">
            <span className="text-base font-extrabold tracking-wide text-white">
              {isOpen ? 'Tutup' : 'ZENTRA AI'}
            </span>
            {!isOpen && (
              <span className="text-[10px] text-white/70 font-medium tracking-wider">
                Assistant Website AI
              </span>
            )}
          </div>

          {!isOpen && (
            <div className="flex items-center gap-1.5 ml-1">
              <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></span>
              <span className="text-[8px] text-white/50 font-medium">Online</span>
            </div>
          )}
        </button>
      </div>
    </>
  );
};

export default AIAssistant;
